























import { Vue, Component, Prop } from "vue-property-decorator";

// Enums/Data
import { TranslationsTypes } from "@/data/enums/translations";

// Types
import { ITranslationFormItem } from "@/models/translations";
import { ILanguage } from "@/models/constants";

@Component
export default class TranslationsList extends Vue {
  @Prop({ required: true })
  private translations!: ITranslationFormItem[];

  @Prop({ required: true })
  private languages!: ILanguage[];

  @Prop({ required: true })
  private isProcessing!: boolean;

  @Prop({ required: true })
  private form!: any;

  @Prop({ required: true })
  private formClone!: any;

  @Prop({ default: "text" })
  private fieldType!: string;

  @Prop({ required: true })
  private objectTypeCode!: TranslationsTypes;

  @Prop({ required: true })
  private fieldName!: string;

  private getFieldValue(languageId: ILanguage["id"]) {
    return this.$_.get(
      this.$_.find(this.translations, (translation: ITranslationFormItem) => {
        return translation.language_id === languageId;
      }),
      this.fieldName,
      ""
    );
  }

  private get getPlaceholder() {
    switch (this.objectTypeCode) {
      case TranslationsTypes.PRODUCT:
        return this.$t(
          this.fieldName === "name" ? "_.product_name" : "_.product_description"
        );
      case TranslationsTypes.PRODUCTS_CATEGORY:
        switch (this.fieldName) {
          case "description":
            return this.$t("_.product_category_description");
          case "short_description":
            return this.$t("_.product_category_short_description");
          default:
          case "name":
            return this.$t("_.product_category_name");
        }
      case TranslationsTypes.PROMOTION:
        return this.$t("_.promotion_name");
      case TranslationsTypes.GATEWAY:
        return this.$t("_.payment_instructions");
      case TranslationsTypes.CLIENTS_FIELD:
        return this.$t("_.client_field_name");
      case TranslationsTypes.BASKET_FIELD:
        return this.$t("_.basket_field_name");
      case TranslationsTypes.TICKET_DEPARTMENT:
        return this.$t("_.ticket_department_name");
      default:
        return "";
    }
  }

  private onChange(languageValue: number, languageId: ILanguage["id"]) {
    if (this.$_.isEmpty(languageValue)) {
      if (
        this.$_.find(this.formClone.translations, translation => {
          return translation.language_id === languageId;
        })
      ) {
        this.form.translations = this.$_.map(
          this.form.translations,
          translation => {
            if (translation.language_id === languageId) {
              translation[this.fieldName] = languageValue;
            }
            return translation;
          }
        );
      } else {
        this.form.translations = this.$_.filter(
          this.form.translations,
          translation => {
            return translation.language_id !== languageId;
          }
        );
      }
    } else {
      if (
        this.$_.find(this.form.translations, translation => {
          return translation.language_id === languageId;
        })
      ) {
        this.form.translations = this.$_.map(
          this.form.translations,
          translation => {
            if (translation.language_id === languageId) {
              translation[this.fieldName] = languageValue;
            }
            return translation;
          }
        );
      } else {
        const newTranslation = { language_id: languageId };
        newTranslation[`${this.fieldName}`] = languageValue;
        this.form.translations.push(newTranslation);
      }
    }
  }
}
